import React from "react";
import CopyValueButton from "./CopyValueButton";
import { HOSTED_ASSISTANTS, hostedAssistantNames } from "../../../lib/hostedAssistants";
import { hostedMcpUrl } from "../../../lib/hostedMcp";

/**
 * Connecting one more assistant, in the assistant itself, with the same
 * JuDI address and Connect JuDI — no key.
 */

const Step: React.FC<{ n: number; children: React.ReactNode }> = ({
  n,
  children,
}) => (
  <li className="flex gap-3">
    <span
      aria-hidden="true"
      className="flex-shrink-0 w-6 h-6 rounded-full border border-warm-border bg-warm-bg-elevated text-xs font-semibold text-warm-text-secondary flex items-center justify-center"
    >
      {n}
    </span>
    <div className="flex-1 min-w-0 pt-0.5 text-sm text-warm-text-primary">
      {children}
    </div>
  </li>
);

const ConnectAssistant: React.FC = () => {
  const url = hostedMcpUrl();

  return (
    <div className="border border-warm-border rounded-xl p-4 space-y-4">
      <div>
        <p className="text-sm text-warm-text-primary">
          Paste this address in the assistant. {hostedAssistantNames("and")} use
          the same one.
        </p>
        <div className="mt-2 flex items-start gap-2">
          <code className="flex-1 min-w-0 text-xs font-mono px-3 py-2 rounded-soft bg-warm-bg-elevated text-warm-text-primary break-all">
            {url}
          </code>
          <CopyValueButton value={url} label="Copy the JuDI address" />
        </div>
      </div>
      {HOSTED_ASSISTANTS.map((assistant) => (
        <div key={assistant.name}>
          <h5 className="font-heading text-sm text-warm-text-primary mb-2">
            {assistant.name}
          </h5>
          <ol className="space-y-3">
            {assistant.steps.map((step, index) => (
              <Step key={step} n={index + 1}>
                {step}
              </Step>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
};

export default ConnectAssistant;
